import React, { useCallback } from 'react';
// mui components
import { Grid, Typography } from '@mui/material';
import { styled } from '@mui/system';
// components
import ArchiveProjectModalNewUI from './new-ui';
// custom hook
import useToast from 'hooks/useToast';
// icons
import RedCrossIcon from 'assets/icons/cross-red-bold.svg';
// api
import { useUpdateProjectMutation, ProjectStatusesEnum } from 'redux-store/api/projects';

const StyledHeading = styled(Typography)({
  fontSize: '14px',
  lineHeight: '20px',
  fontWeight: 'bold',
  color: '#1A1F36',
});

const StyledItem = ({ text }: { text: string }) => {
  return (
    <Grid
      container
      alignItems="center"
      sx={{
        padding: '20px',
        marginBottom: '6px',
        backgroundColor: 'rgba(235, 238, 246, 0.42)',
        borderRadius: '4px',
        '& svg': {
          marginRight: '28px',
        },
      }}
    >
      <RedCrossIcon />
      <Typography
        sx={{
          fontSize: '13px',
          lineHeight: '20px',
          fontWeight: 900,
          color: '#535F77',
        }}
      >
        {text}
      </Typography>
    </Grid>
  );
};
const StyledItemNewUI = ({ text }: { text: string }) => {
  return (
    <Grid
      container
      alignItems="center"
      sx={{
        marginBottom: '6px',
        gap: '10px',
      }}
    >
      <Typography
        sx={{ width: '6px', height: '6px', background: '#D4D6E0', borderRadius: '50%' }}
      ></Typography>
      <Typography
        sx={{
          fontSize: '14px',
          lineHeight: '146%',
          fontWeight: 400,
          color: '#23252F',
          fontFamily: 'Inter, sans-serif !important',
        }}
      >
        {text}
      </Typography>
    </Grid>
  );
};

interface OwnProps {
  open: boolean;
  projectId: number;
  withoutRefetching?: boolean;
  handleClose: () => void;
  handleArchiveProject?: () => void;
}

const ArchiveProjectModal: React.FC<OwnProps> = ({
  open,
  projectId,
  withoutRefetching,
  handleClose,
  handleArchiveProject,
}) => {
  const showToast = useToast();
  const [updateProject, { isLoading: loading }] = useUpdateProjectMutation();

  const onSubmit = useCallback(() => {
    updateProject({
      id: projectId,
      withoutRefetching,
      data: { status: ProjectStatusesEnum.ARCHIVED },
    })
      .unwrap()
      .then(() => {
        showToast({ type: 'success', message: 'Your project has been archived.' });
        handleArchiveProject?.();
      })
      .catch((err) => {
        showToast({
          type: 'error',
          message:
            typeof err?.data?.message === 'string'
              ? err.data.message
              : 'Something went wrong.  Please try again or contact support for help.',
        });
      });
  }, [updateProject, projectId, handleArchiveProject, showToast]);

  const props = {
    open,
    projectId,
    loading,
    StyledHeading,
    handleClose,
    onSubmit,
    StyledItem,
    StyledItemNewUI,
  };

  return <ArchiveProjectModalNewUI {...props} />;
};

export default ArchiveProjectModal;
